export default __webpack_public_path__ + "static/media/consult.c075a04f.svg";